<div class="row">
    <div class="col-lg-12" style="padding: 0px">
        <section class="widget">
            <!-- título -->
            <header>
                <h3> {{sistemaService.NombrePantallaActual}}: {{accion.accion}}</h3>
            </header>
            <div class="divisor20"></div>
            <mat-tab-group #tab preserveContent mat-stretch-tabs>                
                <mat-tab label="Datos generales">  
                    <colaborador_general #general 
                        [id]="id"
                        [disabled]="accion.accionid == 2"
                        (salir)="Salir()">
                    </colaborador_general>
                </mat-tab>
                <mat-tab label="Horarios"> 
                    <colaborador_horario *ngIf="id"
                        [id]="id"
                        [disabled]="accion.accionid == 2">                        
                    </colaborador_horario>
                </mat-tab>
                <mat-tab label="Estudios"> 
                    <colaborador_estudio *ngIf="id"
                        [id]="id"
                        [disabled]="accion.accionid == 2">
                    </colaborador_estudio>
                </mat-tab>
                <mat-tab label="Puestos"> 
                    <colaborador_puesto *ngIf="id"
                        [id]="id"
                        [disabled]="accion.accionid == 2">
                    </colaborador_puesto>
                </mat-tab>
            </mat-tab-group>

            <div class="divisor20"></div>
            <div class="row margen">
                <div class="col-12">
                    <div class="panelBotonesFiltro">
                        <button class="boton botonSM filledBlanco" (click)="Salir()">
                            <span> {{'Salir'}}</span>
                        </button>
                        <div class="divisorH16 " *ngIf="tab.selectedIndex != 0"></div>
                        <button class="boton botonSM filledBlanco" (click)="Atras()" *ngIf="tab.selectedIndex != 0">
                            <span> {{'Atras'}}</span>
                        </button>
                        <div class="divisorH16 "></div>
                        <button class="boton botonSM filled" (click)="Guardar()">
                            <span *ngIf="tab.selectedIndex == 0 &&  accion.accionid != 2"> {{'Guardar'}}</span>
                            <span *ngIf="(tab.selectedIndex == 0 &&  accion.accionid == 2) || tab.selectedIndex == 1 || tab.selectedIndex == 2"> {{'Siguiente'}}</span>
                            <span *ngIf="tab.selectedIndex == 3"> {{'Finalizar'}}</span>
                        </button>
                    </div>
                </div>
            </div>

        </section>
    </div>
    <div class="col-lg-12" style="padding: 0px">

    </div>
</div>